export function findoutLastMonth() {
  const monthNames = [
    "January",
    "February",
    "March",
    "April",
    "May",
    "June",
    "July",
    "August",
    "September",
    "October",
    "November",
    "December",
  ];

  const today = new Date();
  today.setMonth(today.getMonth() - 1); // This sets the month in date object
  const lastMonth = today.getMonth();

  return monthNames[lastMonth];
}
